// @flow strict

import React, { type Node } from 'react';
import { createSvgIcon } from '@material-ui/core/utils';

/**
 * Type of component properties.
 */
type SvgIconProps = {
  name: string,
  children: Node,
  viewBox?: string,
  className?: string,
};

/**
 * Type of component that use svgIcon wrapper component.
 */
export type SvgIconComponentProps = {|
  viewBox?: string,
  className?: string,
  onClick?: () => void,
|};

/**
 * Wrapper component for svg icons.
 * Creates svg icon with material-ui helper function, and passes
 * down props.
 *
 * @param {SvgIconProps} props - component props.
 *
 * @returns {Node}
 */
export const SvgIcon = (props: SvgIconProps) => {
  const { name, children, ...other } = props;
  const SvgIconComponent = createSvgIcon(children, name);

  return <SvgIconComponent {...other} />;
};
